/**
 * Bead Selector Bridge
 * Connecte les selections de perles au bracelet dynamique
 * - Pattern alternance stricte des perles selectionnees
 * - Breloque au centre du bracelet
 */
(function() {
    'use strict';

    var sizeConfiguration = {
        '6mm': {
            '14cm': 26, '15cm': 27, '16cm': 29, '17cm': 31, '18cm': 33,
            '19cm': 34, '20cm': 36, '21cm': 38, '22cm': 40, '23cm': 42
        },
        '8mm': {
            '14cm': 21, '15cm': 22, '16cm': 23, '17cm': 24, '18cm': 25,
            '19cm': 26, '20cm': 28, '21cm': 29, '22cm': 30, '23cm': 31
        }
    };

    var currentTextures = {};
    var currentBeadSize = '6mm';
    var currentBraceletSize = '17cm';
    var currentBreloqueImage = null;
    var currentBreloqueName = null;

    // Ecouter les changements de perles
    document.addEventListener('beadSelectionChange', function(e) {
        var detail = e.detail || {};
        currentTextures = detail.textures || {};
        currentBeadSize = detail.beadSize || '6mm';
        currentBraceletSize = detail.braceletSize || '17cm';
        renderBracelet();
    });

    // Ecouter les changements de breloque
    document.addEventListener('breloqueChange', function(e) {
        var detail = e.detail || {};
        currentBreloqueImage = detail.image || null;
        currentBreloqueName = detail.name || null;
        updateBreloque(currentBreloqueImage, currentBreloqueName);
    });

    function initBracelet() {
        // Lire l'etat initial si bead-selector.js a deja selectionne des perles
        if (window.beadSelector) {
            var bs = window.beadSelector;
            if (bs.selectedTextures) {
                Object.keys(bs.selectedTextures).forEach(function(k) {
                    if (bs.selectedTextures[k]) currentTextures[k] = bs.selectedTextures[k];
                });
            }
        }
        renderBracelet();
    }

    function renderBracelet() {
        var mediaWrapper = document.querySelector('.product-information__media');
        if (!mediaWrapper) return;

        var sizeConfig = sizeConfiguration[currentBeadSize];
        var beadsNumber = (sizeConfig && sizeConfig[currentBraceletSize]) || 31;

        // Collecter uniquement les textures selectionnees (pattern alternance stricte)
        var textureArray = [];
        Object.keys(currentTextures).sort().forEach(function(k) {
            if (currentTextures[k]) textureArray.push(currentTextures[k]);
        });

        var imageUrls = textureArray.slice();
        if (imageUrls.length > 0) {
            preloadImages(imageUrls, function() {
                generateBracelet(mediaWrapper, textureArray, beadsNumber);
            });
        } else {
            generateBracelet(mediaWrapper, textureArray, beadsNumber);
        }
    }

    function preloadImages(urls, callback) {
        var loaded = 0;
        var total = urls.length;
        if (total === 0) { callback(); return; }
        urls.forEach(function(url) {
            var img = new Image();
            img.onload = img.onerror = function() {
                loaded++;
                if (loaded >= total) callback();
            };
            img.src = url;
        });
    }

    function generateBracelet(mediaWrapper, textureArray, beadsNumber) {
        var existing = mediaWrapper.querySelector('.dynamic-bracelet');
        if (existing) existing.remove();

        var diametreBead = parseInt(currentBeadSize) * 6;
        var diametreBracelet = (diametreBead * beadsNumber) / Math.PI;

        var centerX = diametreBracelet / 2;
        var centerY = diametreBracelet / 2;

        var dynamicBracelet = document.createElement('div');
        dynamicBracelet.className = 'dynamic-bracelet';
        dynamicBracelet.style.cssText = '--bracelet-size:' + diametreBracelet + 'px;--bead-size:' + diametreBead + 'px';

        // Trouver la perle la plus proche du bas exact (angle pi/2)
        var bottomAngle = Math.PI / 2;
        var closestIndex = 0;
        var closestDiff = Infinity;
        for (var j = 0; j < beadsNumber; j++) {
            var a = (j / beadsNumber) * Math.PI * 2;
            var diff = Math.abs(a - bottomAngle);
            if (diff < closestDiff) {
                closestDiff = diff;
                closestIndex = j;
            }
        }

        for (var i = 0; i < beadsNumber; i++) {
            var angle = (i / beadsNumber) * Math.PI * 2;
            var x = centerX + (diametreBracelet / 2) * Math.cos(angle);
            var y = centerY + (diametreBracelet / 2) * Math.sin(angle);

            var bead = document.createElement('span');
            bead.className = 'dynamic-bracelet__bead';
            bead.style.top = (y - diametreBead / 2) + 'px';
            bead.style.left = (x - diametreBead / 2) + 'px';

            // Marquer la perle la plus proche du bas
            if (i === closestIndex) {
                bead.setAttribute('data-mid', 'true');
                if (currentBreloqueImage) bead.style.display = 'none';
            }

            // Pattern alternance stricte : cycle uniquement sur les perles selectionnees
            if (textureArray.length > 0) {
                var textureUrl = textureArray[i % textureArray.length];
                bead.style.backgroundImage = 'url(' + textureUrl + ')';
            }

            dynamicBracelet.appendChild(bead);
        }

        // Breloque : toujours pile en bas (angle pi/2)
        var midX = centerX + (diametreBracelet / 2) * Math.cos(bottomAngle);
        var midY = centerY + (diametreBracelet / 2) * Math.sin(bottomAngle);
        var breloqueSize = Math.round(diametreBead * 1.6);

        var breloqueEl = document.createElement('div');
        breloqueEl.className = 'breloque-center';
        breloqueEl.style.top = (midY - breloqueSize / 2) + 'px';
        breloqueEl.style.left = (midX - breloqueSize / 2) + 'px';
        breloqueEl.style.width = breloqueSize + 'px';
        breloqueEl.style.height = breloqueSize + 'px';
        breloqueEl.style.display = 'none';
        dynamicBracelet.appendChild(breloqueEl);

        mediaWrapper.appendChild(dynamicBracelet);

        // Re-appliquer la breloque si deja selectionnee
        if (currentBreloqueImage) {
            updateBreloque(currentBreloqueImage, currentBreloqueName);
        }
    }

    function updateBreloque(imageUrl, name) {
        var breloqueEl = document.querySelector('.breloque-center');
        var midBead = document.querySelector('.dynamic-bracelet__bead[data-mid="true"]');
        if (!breloqueEl) return;

        if (imageUrl) {
            if (midBead) midBead.style.display = 'none';
            breloqueEl.innerHTML = '<img src="' + imageUrl + '" alt="' + (name || 'Breloque') + '" style="width:100%;height:100%;object-fit:contain;">';
            breloqueEl.style.display = 'block';
        } else {
            if (midBead) midBead.style.display = '';
            breloqueEl.innerHTML = '';
            breloqueEl.style.display = 'none';
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBracelet);
    } else {
        initBracelet();
    }
})();
